/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NotificationPreference model module.
 * @module model/NotificationPreference
 * @version 1.1.0
 */
class NotificationPreference {
    /**
     * Constructs a new <code>NotificationPreference</code>.
     * Notification preference settings for a single topic and user
     * @alias module:model/NotificationPreference
     * @param topic {module:model/NotificationPreference.TopicEnum} 
     */
    constructor(topic) { 
        
        NotificationPreference.initialize(this, topic);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, topic) { 
        obj['topic'] = topic;
        obj['emailEnabled'] = false;
        obj['smsEnabled'] = false;
        obj['pushEnabled'] = false;
    }

    /**
     * Constructs a <code>NotificationPreference</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NotificationPreference} obj Optional instance to populate.
     * @return {module:model/NotificationPreference} The populated <code>NotificationPreference</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NotificationPreference();

            if (data.hasOwnProperty('topic')) {
                obj['topic'] = ApiClient.convertToType(data['topic'], 'String');
            }
            if (data.hasOwnProperty('emailEnabled')) {
                obj['emailEnabled'] = ApiClient.convertToType(data['emailEnabled'], 'Boolean');
            }
            if (data.hasOwnProperty('smsEnabled')) {
                obj['smsEnabled'] = ApiClient.convertToType(data['smsEnabled'], 'Boolean');
            }
            if (data.hasOwnProperty('pushEnabled')) {
                obj['pushEnabled'] = ApiClient.convertToType(data['pushEnabled'], 'Boolean');
            }
            if (data.hasOwnProperty('timeLastUpdated')) {
                obj['timeLastUpdated'] = ApiClient.convertToType(data['timeLastUpdated'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NotificationPreference</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NotificationPreference</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of NotificationPreference.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['topic'] && !(typeof data['topic'] === 'string' || data['topic'] instanceof String)) {
            throw new Error("Expected the field `topic` to be a primitive type in the JSON string but got " + data['topic']);
        }

        return true;
    }


}

NotificationPreference.RequiredProperties = ["topic"];

/**
 * @member {module:model/NotificationPreference.TopicEnum} topic
 */
NotificationPreference.prototype['topic'] = undefined;

/**
 * @member {Boolean} emailEnabled
 * @default false
 */
NotificationPreference.prototype['emailEnabled'] = false;

/**
 * @member {Boolean} smsEnabled
 * @default false
 */
NotificationPreference.prototype['smsEnabled'] = false;

/**
 * @member {Boolean} pushEnabled
 * @default false
 */
NotificationPreference.prototype['pushEnabled'] = false;

/**
 * Server-managed timestamp; always ignored on write (POST/PATCH).
 * @member {Date} timeLastUpdated
 */
NotificationPreference.prototype['timeLastUpdated'] = undefined;





/**
 * Allowed values for the <code>topic</code> property.
 * @enum {String}
 * @readonly
 */
NotificationPreference['TopicEnum'] = {

    /**
     * value: "fire_controller_activation"
     * @const
     */
    "fire_controller_activation": "fire_controller_activation",

    /**
     * value: "fire_controller_connection_loss"
     * @const
     */
    "fire_controller_connection_loss": "fire_controller_connection_loss",

    /**
     * value: "neighbor_system_activation"
     * @const
     */
    "neighbor_system_activation": "neighbor_system_activation"
};



export default NotificationPreference;

